// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32emP","colMin":"styles_colMin__2l8Zu"};